export const INPUT_TYPE = {
  SELECT: 'SELECT',
  DATE_RANGE: 'DATE_RANGE',
  INPUT: 'INPUT',
  MULTI_SELECT: 'MULTI_SELECT',
  CHECKBOX: 'CHECKBOX',
};

export const ALL_OPTION_ID = 0;

export const HISTORICAL_EVENT_FIELD_NAME = {
  DATE_FILTER: 'dateFilter',
  LEAGUES: 'leagues',
  MATCH_ID: 'filterMatchId',
  TEAMS_NAME: 'filterTeamsName',
  FILTER_SHOW: 'filterShow',
};

export const HISTORICAL_EVENT_QUERY_PARAMS_NAME = {
  START_DATE: 'filterStartDate',
  END_DATE: 'filterEndDate',
  LEAGUES: 'filterLeague[]',
  MATCH_ID: 'filterMatchId',
  TEAMS_NAME: 'filterTeamsName',
  FILTER_SHOW: 'filterShow',
};

// eslint-disable-next-line func-names
export const FILTER_FIELD_CONFIGS = function (props) {
  return [
    {
      id: 'date-filter',
      type: INPUT_TYPE.DATE_RANGE,
      label: 'Date',
      fieldName: HISTORICAL_EVENT_FIELD_NAME.DATE_FILTER,
      initialValue: { from: '', to: '' },
    },
    {
      id: 'leagues',
      type: INPUT_TYPE.MULTI_SELECT,
      label: 'League',
      fieldName: HISTORICAL_EVENT_FIELD_NAME.LEAGUES,
      initialValue: [],
      options: props.leagues.map((league) => ({
        id: league.id,
        label: league.name,
      })),
    },
    {
      id: 'matchId',
      type: INPUT_TYPE.INPUT,
      label: 'Match ID',
      fieldName: HISTORICAL_EVENT_FIELD_NAME.MATCH_ID,
      initialValue: '',
      inputAttributes: {
        placeholder: '-',
        type: 'number',
        className: 'filter__field-input arrowDisabled',
      },
    },
    {
      id: 'teamsName',
      type: INPUT_TYPE.INPUT,
      label: 'Teams Name',
      fieldName: HISTORICAL_EVENT_FIELD_NAME.TEAMS_NAME,
      initialValue: '',
      inputAttributes: {
        placeholder: '-',
        type: 'text',
        className: 'filter__field-input',
      },
    },
    {
      id: 'show',
      type: INPUT_TYPE.SELECT,
      label: 'Show',
      fieldName: HISTORICAL_EVENT_FIELD_NAME.FILTER_SHOW,
      initialValue: ALL_OPTION_ID,
      options: [
        { id: ALL_OPTION_ID, label: 'All' },
        { id: 1, label: 'Only Booked' },
        { id: 2, label: 'Only Available' },
      ],
    },
  ];
};

export const FILTER_LEGENDS = [
  {
    label: 'Ended',
    cssClass: 'ended',
  },
  {
    label: 'Skipped',
    cssClass: 'skipped',
  },
  {
    label: 'Booked',
    cssClass: 'booked',
  },
];
